import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=51501827&scoped=true"
import script from "./ButtonDelete.vue?vue&type=script&lang=js"
export * from "./ButtonDelete.vue?vue&type=script&lang=js"
import style0 from "./ButtonDelete.vue?vue&type=style&index=0&id=51501827&prod&lang=scss&scoped=true"
import style1 from "./ButtonDelete.vue?vue&type=style&index=1&id=51501827&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51501827",
  null
  
)

export default component.exports